module.exports = __webpack_public_path__ + "img/logo-UMSC.24047e5b.svg";